module.exports = __webpack_public_path__ + "static/half-section-with-pattern-362a998dde9ff3976a5f4e6832fb3f77.png";